import AbstractChannel from './AbstractChannel'

export default class Dock extends AbstractChannel {

  name = 'dock'
  title = 'Dock'
  titleShort = 'Dock'
  color = '#FF7F0F'

}
